/**
 * 모달의 활성화 여부를 리턴한다.
 * @param {*} state
 * @returns {boolean}
 */
const isOpen = state => {
  let result = false
  for (let key in state.open) {
    if (state.open[key]) {
      result = true
      break
    }
  }
  return result
}
/**
 * Alert 모달의 활성화 여부를 리턴한다.
 * @param {*} state
 * @returns {boolean}
 */
const isAlertOpen = state => {
  return state.open.alert
}
/**
 * Confirm 모달의 활성화 여부를 리턴한다.
 * @param {*} state
 * @returns {boolean}
 */
const isConfirmOpen = state => {
  return state.open.confirm
}

const noFooter = state => {
  return state.noFooter
}

const showFooterInSecond = state => {
  return state.showFooterInSecond
}

const canCancel = state => {
  return state.canCancel
}
/**
 * 모달의 타이틀을 리턴한다.
 * @param {Object} state
 * @returns {string}
 */
const header = state => state.header
/**
 * 모달의 메시지를 리턴한다.
 * @param {Object} state
 * @returns {string}
 */
const message = state => state.message
/**
 * 모달의 callback을 리턴한다.
 * @param {*} state
 * @returns {Function}
 */
const callback = state => state.callback
const cancelCallback = state => state.cancelCallback

const confirmText = state => state.confirmText

/**
 * 모달의 closeCallback 리턴한다.
 * @param {*} state
 * @returns {Function}
 */
const closeCallback = state => state.closeCallback

export default {
  isOpen,
  isAlertOpen,
  isConfirmOpen,
  noFooter,
  showFooterInSecond,
  header,
  message,
  callback,
  cancelCallback,
  closeCallback,
  canCancel,
  confirmText
}
